function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["pixelDensities", "elementProps", "children"],
  _excluded2 = ["viewport", "preload", "pixelDensity", "__createQuery"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _flatMapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/flat-map";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js/instance/sort";
import PropTypes from "prop-types";
import React, { Children } from "react";
import isSourceNode from "../../utilities/isSourceNode/index.js";
import isImgNode from "../../utilities/isImgNode/index.js";
import { descendingOrderSourceCompare } from "../../utilities/compareFunctions/index.js";
import { mutexMediaQueryFactory } from "../../utilities/createMediaQueriesFromProps/index.js";
var Picture = function Picture(props) {
  var _context;
  var parentPixelDensities = props.pixelDensities,
    elementProps = props.elementProps,
    children = props.children,
    rest = _objectWithoutProperties(props, _excluded);
  var createMutexMediaQuery = mutexMediaQueryFactory(props);
  var lazy = rest.lazy,
    preload = rest.preload,
    host = rest.host,
    env = rest.env,
    quality = rest.quality,
    slug = rest.slug,
    id = rest.id;
  var inheritedProps = {
    lazy: lazy,
    preload: preload,
    host: host,
    env: env,
    quality: quality,
    slug: slug
  };

  // Only inherited if provided
  if (id) {
    inheritedProps.id = id;
  }
  var newChildren = _flatMapInstanceProperty(_context = Children.toArray(children)).call(_context, function (child) {
    if (isSourceNode(child)) {
      var _child$props = child.props,
        viewport = _child$props.viewport,
        sourcePreload = _child$props.preload,
        pixelDensity = _child$props.pixelDensity,
        __createQuery = _child$props.__createQuery,
        childProps = _objectWithoutProperties(_child$props, _excluded2);
      if (id && childProps.id) {
        throw new Error('An id was given to the `Picture` and to the `Source`. The Picture id takes precedence, but you probably did not intend to specify an id to both. For art direction, omit the id in `Picture` component.');
      }

      // Allow child density to override parent
      var pixelDensities = pixelDensity ? [pixelDensity] : parentPixelDensities;
      return _mapInstanceProperty(pixelDensities).call(pixelDensities, function (finalPixelDensity) {
        var key = "source-".concat(finalPixelDensity, "-").concat(viewport);
        return /*#__PURE__*/React.cloneElement(child, _objectSpread(_objectSpread({
          key: key,
          viewport: viewport,
          pixelDensity: finalPixelDensity,
          __createQuery: createMutexMediaQuery
        }, childProps), inheritedProps));
      });
    }
    if (isImgNode(child)) {
      if (id && child.props.id) {
        throw new Error('An id was given to the `Picture` and to the `Source`. The Picture id takes precedence, but you probably did not intend to specify an id to both. For art direction, omit the id in `Picture` component.');
      }
      return /*#__PURE__*/React.cloneElement(child, _objectSpread(_objectSpread(_objectSpread({}, child.props), inheritedProps), {}, {
        /**
         * Don't preload img element source when used with picture component
         * This creates complications because it requires creating a media query that is mutually
         * exclusive from all others
         *
         * When using `Img` component under a `Picture` component, it helps to think of it as
         * a progressive enhancement strategy -- as a fallback for browsers that don't support
         * picture and source.
         *
         * If consumers want to preload the img src, they should use the `Img` component
         * by itself
         */
        preload: false
      }));
    }
    return child;
  });

  /**
   * Sort children to make sure media queries are properly organized (from most specific to least specific)
   *
   * Without this step, consumers can accidentally load larger/smaller images than desired
   */
  _sortInstanceProperty(newChildren).call(newChildren, descendingOrderSourceCompare);
  return /*#__PURE__*/React.createElement("picture", elementProps, newChildren);
};
Picture.defaultProps = {
  pixelDensities: [2, 1.5, 1]
};
process.env.NODE_ENV !== "production" ? Picture.propTypes = {
  /**
   * Whether or not to preload the image. Requires setting up a way to extract the preloads. See examples above.
   */
  preload: PropTypes.bool,
  /**
   * Media API host.
   *
   * This is completely optional. The component will try and determine the appropriate host by:
   *
   * - Checking the `UNION_MEDIA_API_HOST` environment variable
   * - Falling back to the default hosts for qa and production, depending on the value of `env`
   */
  host: PropTypes.string,
  /**
   * Media API environment to use
   *
   * This is completely optional. The component will try and determine the appropriate host by:
   *
   * - Checking if `NODE_ENV` is `production`
   * - Checking the value of `UNION_MEDIA_API_ENV` or `UNION_DEPLOYMENT_ENV`
   * - Falling back to `qa`
   */
  env: PropTypes.oneOf(['qa', 'production']),
  /**
   * List of supported pixel densities
   */
  pixelDensities: PropTypes.arrayOf(PropTypes.number),
  /**
   * Source and Img elements. The component will try to sort the elements to ensure the media
   * do not conflict with eachother
   */
  children: PropTypes.node,
  /**
   * Weather or not to enable lazy loading
   */
  lazy: PropTypes.bool,
  /**
   * Set the quality parameter to all images. [See Media API's documentation](https://api-docs.eng.xogrp.com/details/production-media-api).
   */
  quality: PropTypes.string,
  /**
   * Add a slug to the image url. [See Media API's documentation](https://api-docs.eng.xogrp.com/details/production-media-api)
   */
  slug: PropTypes.string,
  /**
   * Image id
   */
  id: PropTypes.string,
  /**
   * props to pass to `picture` element
   */
  elementProps: PropTypes.shape()
} : void 0;
export default Picture;